"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var paperArea_1 = require("../diagram/paperArea");
var authoringTools_1 = require("../widgets/authoringTools");
var classTree_1 = require("../widgets/classTree");
var instancesSearch_1 = require("../widgets/instancesSearch");
var linksToolbox_1 = require("../widgets/linksToolbox");
var react_1 = require("../viewUtils/react");
var resizableSidebar_1 = require("./resizableSidebar");
var accordion_1 = require("./accordion");
var accordionItem_1 = require("./accordionItem");
var INTRO_CLASSES = "<p>Navigate through class tree and click a class to select it.</p>\n<p>When the class is selected, its instances are shown in Instances panel</p>\n<p>Double-click the class expands it and displays its subclasses.</p>";
var INTRO_INSTANCES = "<p>Instances of the selected class are displayed here.</p>\n<p>You can select one or several instances and drag-and-drop them directly on canvas to\n start your diagram.</p>";
var INTRO_DIAGRAM = "<h4>Main working area</h4><p><b>Zooming:</b> Ctrl-mousewheel or pinch-zoom on touchpad</p>\n<p><b>Pan:</b> Ctrl-mouse drag or mouse wheel</p><h5>Filtering related instances</h5>\n<p>When you select an element on the diagram the Ontodia shows a funnel icon underneath the\n element. By clicking the funnel icon, you can filter the related elements into the Instances panel.</p>\n<p>Then related elements can be drag-and-dropped into the diagram.</p>\n<p>By repeating it you can navigate from one element to another as far as you like and your way\n will be shown on the diagram.</p>";
var INTRO_CONNECTIONS = "<p>Connections panel lists all the connection present in the data source.</p>\n<p>You can define which connections Ontodia should display and which should stay hidden.</p>\n<p>You can also change the way they are shown on the diagram: it\u2019s either with the name above\n them or without it.</p>";
var INTRO_RESIZE = "<p>Panels can be resized and collapsed.</p>";
exports.WorkspaceContextTypes = {
    ontodiaWorkspace: react_1.PropTypes.anything,
};
var WorkspaceMarkup = /** @class */ (function (_super) {
    tslib_1.__extends(WorkspaceMarkup, _super);
    function WorkspaceMarkup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.untilMouseUpClasses = [];
        _this.renderToolbar = function () {
            var _a = _this.props, hideToolbar = _a.hideToolbar, toolbar = _a.toolbar;
            if (hideToolbar) {
                return null;
            }
            return React.createElement("div", { className: 'ontodia__header' }, toolbar);
        };
        _this.renderLeftPanel = function () {
            var _a = _this.props, hidePanels = _a.hidePanels, editor = _a.editor, _b = _a.searchCriteria, searchCriteria = _b === void 0 ? {} : _b;
            if (hidePanels) {
                return null;
            }
            var items = [];
            items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'classTree', heading: 'Classes', tutorialProps: {
                    'data-position': 'right',
                    'data-step': '1',
                    'data-intro-id': 'tree-view',
                    'data-intro': INTRO_CLASSES,
                } },
                React.createElement(classTree_1.ClassTree, { view: _this.props.view, editor: _this.props.editor, onClassSelected: function (classId) {
                        var elementType = _this.props.model.createClass(classId);
                        _this.props.onSearchCriteriaChanged({ elementType: elementType });
                    } })));
            if (editor.inAuthoringMode) {
                items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'authoringTools', heading: 'Authoring Tools' },
                    React.createElement(authoringTools_1.AuthoringTools, { view: _this.props.view, editor: _this.props.editor, metadataApi: _this.props.metadataApi, selectedElementType: searchCriteria.elementType })));
            }
            items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'instancesSearch', heading: 'Instances', tutorialProps: {
                    'data-position': 'top',
                    'data-step': '2',
                    'data-intro-id': 'filter-view',
                    'data-intro': INTRO_INSTANCES,
                } },
                React.createElement(instancesSearch_1.InstancesSearch, { view: _this.props.view, model: _this.props.model, criteria: searchCriteria, onCriteriaChanged: _this.props.onSearchCriteriaChanged })));
            return (React.createElement(resizableSidebar_1.ResizableSidebar, { dockSide: resizableSidebar_1.DockSide.Left, isOpen: _this.props.isLeftPanelOpen, onOpenOrClose: _this.props.onToggleLeftPanel, onStartResize: function () { return _this.untilMouseUp({
                    preventTextSelection: true,
                    horizontalResizing: true,
                }); }, tutorialProps: {
                    'data-position': 'right',
                    'data-step': '7',
                    'data-intro-id': 'resize',
                    'data-intro': INTRO_RESIZE,
                } },
                React.createElement(accordion_1.Accordion, { key: "accordion--" + (editor.inAuthoringMode ? 'exploring' : 'authoring'), onStartResize: function () { return _this.untilMouseUp({
                        preventTextSelection: true,
                        verticalResizing: true,
                    }); } }, items)));
        };
        _this.renderRightPanel = function () {
            if (_this.props.hidePanels) {
                return null;
            }
            return (React.createElement(resizableSidebar_1.ResizableSidebar, { dockSide: resizableSidebar_1.DockSide.Right, isOpen: _this.props.isRightPanelOpen, onOpenOrClose: _this.props.onToggleRightPanel, onStartResize: function () { return _this.untilMouseUp({
                    preventTextSelection: true,
                    horizontalResizing: true,
                }); } },
                React.createElement(accordion_1.Accordion, { onStartResize: function () { return _this.untilMouseUp({
                        preventTextSelection: true,
                        verticalResizing: true,
                    }); } },
                    React.createElement(accordionItem_1.AccordionItem, { heading: 'Connections', bodyClassName: 'link-types-toolbox', tutorialProps: {
                            'data-position': 'left',
                            'data-step': '4',
                            'data-intro-id': 'link-types-toolbox',
                            'data-intro': INTRO_CONNECTIONS,
                        } },
                        React.createElement(linksToolbox_1.LinkTypesToolbox, { view: _this.props.view, editor: _this.props.editor })))));
        };
        _this.onDocumentMouseUp = function () {
            for (var _i = 0, _a = _this.untilMouseUpClasses; _i < _a.length; _i++) {
                var className = _a[_i];
                _this.element.classList.remove(className);
            }
            _this.untilMouseUpClasses = [];
        };
        return _this;
    }
    WorkspaceMarkup.prototype.getChildContext = function () {
        var editor = this.props.editor;
        var ontodiaWorkspace = { editor: editor };
        return { ontodiaWorkspace: ontodiaWorkspace };
    };
    WorkspaceMarkup.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (e) { return _this.element = e; }, className: 'ontodia' },
            this.renderToolbar(),
            React.createElement("div", { className: 'ontodia__workspace' },
                this.renderLeftPanel(),
                React.createElement("div", { className: 'ontodia__main-panel', "data-position": 'left', "data-step": '3', "data-intro-id": 'diagram-area', "data-intro": INTRO_DIAGRAM },
                    React.createElement(paperArea_1.PaperArea, { ref: function (el) { return _this.paperArea = el; }, view: this.props.view, zoomOptions: this.props.zoomOptions, onDragDrop: function (e, position) { return _this.props.editor.onDragDrop(e, position); }, onZoom: this.props.onZoom })),
                this.renderRightPanel())));
    };
    WorkspaceMarkup.prototype.componentDidMount = function () {
        document.addEventListener('mouseup', this.onDocumentMouseUp);
    };
    WorkspaceMarkup.prototype.componentWillUnmount = function () {
        document.removeEventListener('mouseup', this.onDocumentMouseUp);
    };
    WorkspaceMarkup.prototype.preventTextSelection = function () {
        this.untilMouseUp({ preventTextSelection: true });
    };
    WorkspaceMarkup.prototype.untilMouseUp = function (params) {
        this.untilMouseUpClasses = [];
        if (params.preventTextSelection) {
            this.untilMouseUpClasses.push('ontodia--unselectable');
        }
        if (params.horizontalResizing) {
            this.untilMouseUpClasses.push('ontodia--horizontal-resizing');
        }
        if (params.verticalResizing) {
            this.untilMouseUpClasses.push('ontodia--vertical-resizing');
        }
        for (var _i = 0, _a = this.untilMouseUpClasses; _i < _a.length; _i++) {
            var className = _a[_i];
            this.element.classList.add(className);
        }
    };
    WorkspaceMarkup.childContextTypes = exports.WorkspaceContextTypes;
    return WorkspaceMarkup;
}(React.Component));
exports.WorkspaceMarkup = WorkspaceMarkup;
exports.default = WorkspaceMarkup;
